// Here is a list of the toolbar
// Detail list see https://www.tinymce.com/docs/advanced/editor-control-identifiers/#toolbarcontrols

const toolbar = ["searchreplace bold fontsizeselect   italic underline strikethrough alignleft aligncenter alignright outdent indent  blockquote undo redo removeformat subscript superscript code codesample", "hr bullist numlist link image charmap preview lineheight anchor pagebreak insertdatetime media table emoticons forecolor backcolor fullscreen  tiny_mce_wiris_formulaEditor"];

export default toolbar;
